import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
        return {selector: to.hash}
    } else {
        return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/delivery',
      name: 'delivery',
      component: () => import(/* webpackChunkName: "delivery" */ './views/Delivery.vue')
    },
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "delivery" */ './views/Order.vue')
    },
    { 
      path: "/404", 
      name: '404',
      component: () => import(/* webpackChunkName: "delivery" */ './views/PageNotFound.vue')
    },
    { 
      path: '*', 
      redirect: '/404' 
    }
  ]
})
